import React, {
  useState,
  useCallback,
  useEffect,
  useMemo,
  useRef,
} from "react";
import { MapContainer, TileLayer, useMap } from "react-leaflet";
import ModalInfo from "../fromLoc/modal";
import "leaflet/dist/leaflet.css";
import TextField from "@mui/material/TextField";
import { Typography, Autocomplete, Box, Popper } from "@mui/material";
// const center = [35.6999838, 51.3382364];
const zoom = 16;
const styles = (theme) => ({
  popper: {
    width: "fit-content",
  },
});
const PopperMy = function (props) {
  return <Popper {...props} placement="bottom-start" />;
};
function ChangeView({ center, zoom }) {
  const map = useMap();
  map.setView(center, zoom);
  return null;
}
function DisplayPosition({ map }) {
  const [position, setPosition] = useState(() => map.getCenter());
  const [center, setCenter] = useState([]);
  const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  };

  function success(pos) {
    if (pos === !undefined && null) {
      const crd = pos.coords;

      // // console.log('Your current position is:');
      // // console.log(`Latitude : ${crd.latitude}`);
      // // console.log(`Longitude: ${crd.longitude}`);
      // // console.log(`More or less ${crd.accuracy} meters.`);
      setCenter(crd);
    } else {
      const crd = [53.688, 32.4279];
      setCenter(crd);
    }
  }

  function error(err) {
    console.warn(`ERROR(${err.code}): ${err.message}`);
  }

  navigator.geolocation.getCurrentPosition(success, error, options);

  const onMove = useCallback(() => {
    setPosition(map.getCenter());
  }, [map]);

  useEffect(() => {
    success();
    map.on("move", onMove);
    return () => {
      map.off("move", onMove);
    };
  }, [map, onMove]);
  const [open, setOpen] = React.useState(false);
  const handleOpen = async () => {
    await setOpen(true);
  };
  const handleClose = () => setOpen(false);
  return (
    <ModalInfo
      lat={position.lat}
      lng={position.lng}
      //   address={address}
      //   getAdrs={getAdrs}
      open={open}
      handleOpen={handleOpen}
      handleClose={handleClose}
    />
  );
}

export default function Map({ loc }) {
  const [map, setMap] = useState(null);
  const [options, setOptions] = useState([]);
  const [today, setDay] = useState([]);
  const [center, setCenter] = useState([35.6999838, 51.3382364]);
  const previousController = useRef();
  useEffect(() => {
    loc 
      ? setCenter((oldArray) => [loc?.y,loc?.x])
      : setCenter([35.6999838, 51.3382364]);
  }, [loc]);
  // console.log(loc);
  if (map) {
    map.flyTo(center);
  }
  const displayMap = useMemo(
    () => (
      <>
        <MapContainer
          center={center}
          zoom={zoom}
          style={{ height: "100vh" }}
          scrollWheelZoom={false}
          ref={setMap}
        >
          {/* <ChangeView center={center} zoom={zoom} /> */}

          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
        </MapContainer>
      </>
    ),
    []
  );

  return (
    <div>
      {map ? <DisplayPosition map={map} /> : null}
      {displayMap}
    </div>
  );
}
